import React from "react";
import { styled } from "../../stitches.config";
import { bodyLarge, bodyStrong } from "../commonStyles/Fonts";
import AuthorLinkIcon from "../assets/icons/author-link-icon.svg";
import CopyButton from "./CopyButton"

interface Props {
  backgroundColor?: "grayscale10";
  title?: string;
  description?: string;
  link?: string;
}

const RecruitmentBox: React.FC<Props> = ({
  backgroundColor,
  title,
  description,
  link,
}) => {
  return (
    <Wrapper>
      <OverlayTitle className={bodyStrong()} backgroundColor={backgroundColor}>
        {title || "Rekrutujemy"}
      </OverlayTitle>
      <Content>
        <p className={bodyLarge()}>
          {description || "Chcesz dołączyć do zespołu na:Temat?"}
        </p>
        <p className={bodyLarge()}>
          Prześlij nam swoje CV. Do zgłoszenia załącz swoje portfolio i opisz
          krótko, o czym chciałbyś dla nas pisać.
        </p>
        <p className={bodyLarge()}>
          Kontakt:
          <br />
          <div className="copy-button">
            <CopyButton text={link || "praca@natemat.pl"} />
          </div>
        </p>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled("div", {
  border: "2px solid $grayscale100",
  borderLeft: "none",
  borderRight: "none",
  position: "relative",
  paddingTop: "6px",
});

const OverlayTitle = styled("p", {
  position: "absolute",
  background: "$grayscale0",
  color: '$grayscale100',
  margin: 0,
  padding: "0 16px 0 0",
  top: 0,
  transform: "translateY(-50%)",
  variants: {
    backgroundColor: {
      grayscale10: {
        backgroundColor: "$grayscale10",
      },
    },
  },
});

const Content = styled("div", {
  maxWidth: "85%",

  "& .copy-button": {
    "& svg": {
      "& path": {
        fill: "$grayscale75",
      }
    },
    "& div": {
      textDecoration: "underline",
    },
  },
  p: {
    color: "$grayscale75",
  }
});

const UnderlineText = styled("span", {
  textDecoration: "underline",
  color: "$natematPrimary",
});

export default RecruitmentBox;
